<template>
  <div class="custom-wrapper">
    <router-view />
    <div class="container mt-5">
      <hr />
      <pre class="text-right text-muted">v{{ version }}</pre>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

// Use optional chaining just in case `window.config` is undefined
const version = ref(window.config?.version || '')
</script>

<style scoped>
.custom-wrapper {
  width: 100%;
  min-height: calc(100vh - 105px);
  margin: 0 auto -80px;
  padding: 25px;
}
</style>
